import React from 'react'
import { reactular } from '@vendhq/reactular'
import classNames from 'classnames'
import { getFeatureFromCache } from '../../util/feature-cache'
import { SaleFooter } from './sale-footer/sale-footer'
import { SaleSummary } from './sale-summary/sale-summary'
import { SaleCustomerSearch } from './sale-customer-search/sale-customer-search'
import { SalePayments } from './sale-payment/sale-payment'
import { SaleBanner } from './sale-banner/SaleBanner'

export const SaleView: React.FC = () => {
  const useReactSaleSummary = getFeatureFromCache('react_sale_summary')
  return (
    <div
      className={classNames({ sale: useReactSaleSummary })}
      data-testid="react_sale_view"
    >
      {useReactSaleSummary ? (
        <>
          <SaleCustomerSearch />
          <SaleBanner />
          <div className="sale-body" aria-label="sale-body">
            <SaleSummary />
            <SaleFooter />
          </div>
          <SalePayments />
        </>
      ) : null}

      {!useReactSaleSummary ? <SaleFooter /> : null}
    </div>
  )
}

export const ReactSaleViewComponent = reactular(SaleView, [], 'reactWrapper')
